import { Button } from '@ethena/shared-ui/src/components/Button'
import { Pill } from '@ethena/shared-ui/src/components/Pill'
import { MIRROR_URL } from '@ethena/shared-ui/src/constants/url'
import Link from 'next/link'

import { NewsArticle } from '@/components/NewsArticle'
import { SectionHeader } from '@/components/SectionHeader'

export const HighlightsSection = () => {
  const newsData = [
    {
      description: `Introducing the product for a billion people. Today we announce our partnership with Ton blockchain to power finance's most powerful use case: To send, save and pay with a globally accessible dollar. Internet money, now available for Telegram's billion users.`,
      link: 'https://x.com/ethena_labs/status/1917855402919878900',
      logos: ['/ethena.svg', '/cross.svg', '/ton-wordmark.png'],
      title: 'Ethena x Ton: Internet money for a billion people',
    },
    {
      description:
        'Ethena Labs and Securitize today announced the upcoming launch of Converge, a new blockchain designed to support and advance DeFi and tokenized assets. Developed jointly by Ethena and Securitize, Converge is a purpose built EVM blockchain, optimized for both retail and institutional DeFi.',
      link: 'https://mirror.xyz/0xF99d0E4E3435cc9C9868D1C6274DfaB3e2721341/UmVelxhKuuCgad0VLF6u9kqxMmmxBps-EJyjYKNbXKM',
      logos: ['/ethena.svg', '/cross.svg', '/securitize.svg'],
      title: 'Converge: Ethena x Securitize creates a new chain',
    },
    {
      description:
        "We are excited to share that USDe has been widely integrated throughout Deribit, the industry's leading options and derivatives exchange. The integration includes the following features.",
      link: 'https://mirror.xyz/0xF99d0E4E3435cc9C9868D1C6274DfaB3e2721341/vtb5LXe937BFLq1ZpZDdJy4G6SGdZEJ8qTvnCrsDFhQ',
      logos: ['/deribit-colored.svg', '/cross.svg', '/USDe.svg'],
      title: 'Deribit USDe Integration',
    },
  ]

  return (
    <section className="landing-section">
      <div className="landing-layout w-full mx-auto flex flex-col items-center justify-center pt-20 hlg:pt-0">
        <div className="mb-10 w-fit xl:hidden xl:hlg:block">
          <Pill>
            <p className="font-inter">News</p>
          </Pill>
        </div>
        <SectionHeader title="Highlights" />
        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 justify-center items-stretch flex-wrap w-full gap-8 mb-[60px]">
          {newsData.map(data => (
            <NewsArticle key={data.title} {...data} />
          ))}
        </div>
        <Button asChild variant="secondary" size="small" aria-label="See All News">
          <Link href={MIRROR_URL} target="_blank" rel="noopener noreferrer">
            See All News
          </Link>
        </Button>
      </div>
    </section>
  )
}
